import { dotnetApi } from '@gik/core/api/ky/dotnetApi';
import { StatusCodes } from 'http-status-codes';
import { UnhandledError } from '../HttpErrors';

export async function uploadInkindCoverPhoto(inkindRouteId: string, base64CoverPhotoImage: string) {
  const result = await dotnetApi.post(`inkinds/${inkindRouteId}/cover-photo`, {
    body: base64CoverPhotoImage,
  });
  if (result.status !== StatusCodes.NO_CONTENT) {
    throw new UnhandledError(`Unexpected response code: ${result.status} ${result.statusText}`);
  }
}

export async function removeInkindCoverPhoto(inkindRouteId: string) {
  const result = await dotnetApi.delete(`inkinds/${inkindRouteId}/cover-photo`);
  if (result.status !== StatusCodes.NO_CONTENT) {
    throw new UnhandledError(`Unexpected response code: ${result.status} ${result.statusText}`);
  }
}
